import Facebook from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import Telegram from '@mui/icons-material/Telegram';
import X from '@mui/icons-material/X';
import YouTube from '@mui/icons-material/YouTube';
import { ReactElement } from 'react';

export enum SocialMediaPlatform {
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  Telegram = 'Telegram',
  X = 'X',
  YouTube = 'YouTube',
}

type SocialMediaPlatformRecord = Record<
  SocialMediaPlatform,
  {
    icon: ReactElement;
    text: string;
    url: string;
  }
>;

export const SOCIAL_MEDIA: SocialMediaPlatformRecord = {
  [SocialMediaPlatform.Facebook]: {
    icon: <Facebook fontSize='small' />,
    text: 'Facebook',
    url: 'https://www.facebook.com/systema.akademie.berlin',
  },
  [SocialMediaPlatform.Instagram]: {
    icon: <Instagram fontSize='small' />,
    text: 'Instagram',
    url: 'https://www.instagram.com/systema.berlin',
  },
  [SocialMediaPlatform.Telegram]: {
    icon: <Telegram fontSize='small' />,
    text: 'Telegram',
    url: 'https://t.me/kriegersein',
  },
  [SocialMediaPlatform.X]: {
    icon: <X fontSize='small' />,
    text: 'X',
    url: 'https://x.com/systema_berlin',
  },
  [SocialMediaPlatform.YouTube]: {
    icon: <YouTube fontSize='small' />,
    text: 'YouTube',
    url: 'https://www.youtube.com/c/KampfkunstFalkoZander',
  },
};
